import { ROLES } from './roles.constants';

// NOTE :: Holding any of these shows Settings in the main menu, the user menu and the medical modals' Settings button
// (session.ts checkForPermissionSettings). Every entry takes part in at least one group of the api settings list
// (config/settings_navigation.php); a permission that opens nothing at all belongs only in
// SETTINGS_HOME_ACCESS_PERMISSIONS below. Six groups need TWO permissions (`permissions_all`) and this list is
// any-of, so it can't ask for both: Staff (`users` + `roles`), Community Support, Field Services, Lost & Found,
// TNVR and Rehome. Holding only one half of such a pair shows the entry and then the home's empty-state message.
const SETTINGS_ACCESS_PERMISSIONS = [
  ROLES.ADOPTIONS_SETTINGS,
  ROLES.ANIMAL_SETTINGS,
  ROLES.BEHAVIOR_SETTINGS,
  ROLES.BITE_SETTINGS,
  ROLES.COMMUNITY_SUPPORT_SETTINGS,
  ROLES.DONATION_SETTINGS_2,
  ROLES.EQUIPMENT_RENTAL_SETTINGS,
  ROLES.FIELD_SERVICES_SETTINGS,
  ROLES.FINANCIAL_SETTINGS,
  ROLES.FOSTER_SETTINGS,
  ROLES.INTAKE_SETTINGS,
  ROLES.INTEGRATIONS,
  ROLES.LOST_FOUND_SETTINGS_2,
  ROLES.MEDICAL_SETTINGS,
  ROLES.OUTCOME_SETTINGS,
  ROLES.PARTNER_SETTINGS,
  ROLES.PEOPLE_SETTINGS,
  ROLES.ROLES,
  ROLES.TRANSPORT_SETTINGS,
  ROLES.UNLIMITED_FORMS,
  ROLES.USERS,
];

// NOTE :: The settings home also opens for everything the legacy settings home accepted (api routes.js →
// SETTINGS_ACCESS_PERMISSIONS), so its buttons ("Settings - Home", "Back to Settings") never land on access-denied.
// These extra permissions open no group on their own, so they earn a home but no menu entry.
const SETTINGS_HOME_ACCESS_PERMISSIONS = [
  ...SETTINGS_ACCESS_PERMISSIONS,
  ROLES.COMMUNITY_SUPPORT,
  ROLES.FIELD_SERVICES,
  ROLES.MANAGE_FORMS,
  ROLES.MANAGE_TAGS,
  ROLES.REHOME_SETTINGS,
  ROLES.TNVR,
];

export { SETTINGS_ACCESS_PERMISSIONS, SETTINGS_HOME_ACCESS_PERMISSIONS };
